import * as React from "react";
import { IContext } from "./models";

export default React.createContext<IContext | null>(null);
